/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
import React from 'react';
import { CheckCircle, Delete, HighlightOff } from '@material-ui/icons';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IconButton } from '@material-ui/core';
import TextWidget from './TextWidget';
import useAutoFilingIntegration from './useAutoFilingIntegration';
import useAlertDialog from '../../../redux/features/alertDialog/useAlertDialog';

export const useClasses = makeStyles(theme => ({
  actions: {
    width: '2rem',
    background: theme.palette.statusChip?.seeMoreBackground,
    borderRadius: '505',
  },
  validationIcon: {
    left: '-3rem',
    position: 'relative',
    '& > svg': {
      width: '2rem',
    },
  },
  invalid: {
    color: theme.palette.statusChip?.invalidBackground,
  },
  valid: {
    color: theme.palette.statusChip?.validBackground,
  },
}));

export default function AutoFillWidget(props) {
  const { rawErrors = [] } = props;
  const classes = useClasses();
  const { openAlertDialog } = useAlertDialog();

  const {
    isAlreadyAutoFilled,
    hasSchemaErrors,
    onInputChange,
    value,
    onBlurDebounced,
    onInputReplace,
  } = useAutoFilingIntegration(props);

  const isValidWidget = () => {
    return value ? (
      <div className={classes.validationIcon}>
        {isAlreadyAutoFilled ? <CheckCircle className={classes.valid} /> : <HighlightOff className={classes.invalid} />}
      </div>
    ) : null;
  };

  const clearFieldButton = () => {
    return value && isAlreadyAutoFilled ? (
      <IconButton
        className={classes.actions}
        data-testid="icon-button"
        aria-label="Remove"
        size="small"
        onClick={() => {
          openAlertDialog({
            updatedTexts: {
              title: 'autocomplete.modal.title',
              message: 'autocomplete.applicant.patent.modal.delete.message',
              confirmButton: 'actions.delete',
              cancelButton: 'actions.cancel',
            },
            updatedSettings: {
              showCancelButton: true,
              showCloseButton: true,
            },
            acceptHandler: {
              func: onInputReplace,
              args: null,
            },
          });
        }}
      >
        <Delete />
      </IconButton>
    ) : null;
  };

  return (
    <div>
      <TextWidget
        {...props}
        size="small"
        value={value}
        hasError={hasSchemaErrors}
        onChange={onInputChange}
        onBlur={onBlurDebounced}
        error={rawErrors.length > 0}
        outerInputRenderer={clearFieldButton}
        innerInputRenderer={isValidWidget}
      />
    </div>
  );
}
